import {
  HEA_OPTIONS,
  HE_OPTIONS,
  HHS_OPTIONS,
  HR_NATURE_OPTIONS,
  HU_EE_OPTIONS,
  HU_HC_OPTIONS,
  HU_HR_OPTIONS,
  HY_OPTIONS,
} from "./Options";

export const QUESTIONS = [
  {
    number: null,
    type: "newSection",
    question: "Step 1: Healthy Me",
    instructions:
      "What do we need to nourish our own mind, body, and spirit? What do we need to feel safe and loved? The youB Healthy Me values are the foundation for personal wellbeing.",
    //instructions: 'Take your time to reflect and consider each value. ',
  },
  /* NEW SECTION */
  {
    number: 1,
    type: "question",
    question: "Healthy Me",
    subheading: "Living Our Healthiest Lives",
    instructions:
      "Let’s look deeply into each of the values to help us grow into our full, healthy selves to better hold ourselves and each other up. There are six Values in this category. Carefully read the definitions, then select two that you most want to be informed about, inspired by, and motivated to act on.",
    options: HY_OPTIONS,
    choiceLimit: 2,
  },
  {
    number: null,
    type: "newSection",
    question: "Top Healthy Me Values - check. Step 2: Healthy Us…",
    instructions:
      "When we come together in community, we build connections that help us all live healthier lives. The youB Values for Healthy Us offer insight into ways we can cultivate equity, equality, healthy relationships, and collaboration.",
    //instructions: 'Take your time to reflect and consider each value. ',
  },
  /* NEW SECTION */
  {
    number: 2,
    type: "question",
    question: "Healthy Us",
    subheading: "Embracing Equity and Equality",
    instructions:
      "If we want a society that’s fair for all, we need to examine our biases and work toward equity in all aspects of our lives. There are five Values in this category. Carefully read the definitions, then select two that you most want to be informed about, inspired by, and motivated to act on.",
    options: HU_EE_OPTIONS,
    choiceLimit: 2,
  },

  {
    number: 3,
    type: "question",
    question: "Healthy Us",
    subheading: "Achieving Healthy Relationships",
    instructions:
      "Our interactions with other people hold the potential for peace and creativity or disharmony. There are five values in this category. Carefully read the definitions, then select two that you most want to be informed about, inspired by, and motivated to act on.",
    options: HU_HR_OPTIONS,
    choiceLimit: 2,
  },
  {
    number: 4,
    type: "question",
    question: "Healthy Us",
    subheading: "Healthy Collaboration",
    instructions:
      "Healthy Collaboration is how we work in our communal environments, whether at a job, somewhere we volunteer, or our local community of neighbors. There are five values in this category. Carefully read the definitions, then select two you most want to be informed about, inspired by, and motivated to act on.",
    options: HU_HC_OPTIONS,
    choiceLimit: 2,
  },

  {
    number: null,
    type: "newSection",
    question:
      "You’ve found the Healthy Us Values that will spark better community work for you, now dig into the Healthy Planet Values in Step 3.",
    instructions:
      "All of life depends on the wellbeing of this planet. The youB Healthy Planet values invite us to come into balance with nature. Through our individual engagement and collective action, we can strengthen our relationships with nature, and shift the human systems that affect the health of our ecosystems. We each have a role to play in creating a sustainable future.",
    //instructions: 'Take your time to reflect and consider each value. ',
  },

  /* NEW SECTION */

  {
    number: 5,
    type: "question",
    question: "Healthy Ecosystems to Sustain Life",
    subheading: "What We All Need for Survival",
    instructions:
      "Earth’s ecosystems are the basis for all life, including humans. There are eight values in this category. Carefully read the definitions, then select the two that you most want to be informed about, inspired by, and motivated to act on.",
    options: HE_OPTIONS,
    choiceLimit: 2,
  },
  {
    number: 6,
    type: "question",
    question: "Healthy Relationships with Nature",
    subheading: "Respect and Reciprocity Through Immersion",
    instructions:
      "We are more likely to protect what we know and love. Caring for our planet starts with our personal relationship with nature. There are two values in this category. Carefully read the definitions, then select one that you most want to be informed about, inspired by, and motivated to act on.",
    options: HR_NATURE_OPTIONS,
    choiceLimit: 1,
  },
  {
    number: 7,
    type: "question",
    question: "Healthy Human Systems",
    subheading: "Innovations and Actions for People and Planet",
    instructions:
      "Let’s reimagine human structures – transform them into life-sustaining systems that are in balance with the natural world.  There are three values in this category. Carefully read the definitions, then select two that you most want to be informed about, inspired by, and motivated to act on.",
    options: HHS_OPTIONS,
    choiceLimit: 2,
  },
  {
    number: 8,
    type: "question",
    question: "Healthy Environmental Actions",
    subheading: "Impactful Actions for a Healthier Planet",
    instructions:
      "We can come into balance with nature by making healthier choices that take into account the full life-cycle of the things we purchase, make and use, and their impact on the greater whole. Carefully read the definitions, then select one that you most want to be informed about, inspired by, and motivated to act on.",
    options: HEA_OPTIONS,
    choiceLimit: 1,
  },
  /* NEW SECTION */
  {
    number: null,
    type: "newSection",
    question:
      "Congratulations! Your Self-Reflection results are ready for fine-tuning.",
    instructions:
      "Step 4: Starting with the Values you’ve selected so far, let’s narrow them down to those you are most passionate about.",
  },
  {
    number: 9,
    type: "question",
    question:
      "Among the 2 Healthy Me Values you selected in Question 1, select your top 1 now.",
    instructions: "",
    choiceLimit: 1,
  },
  {
    number: 10,
    type: "question",
    question:
      "Among the 6 Healthy Us Values you selected in Questions 2-4, select your top 2 now.",
    instructions: "",
    choiceLimit: 2,
  },
  {
    number: 11,
    type: "question",
    question:
      "Among the 6 Healthy Planet Values you selected in Questions 5-8, select your top 2 now.",
    instructions: "",
    choiceLimit: 2,
  },
  {
    number: 12,
    type: "form",
    question: "Nice! You’ve arrived at your top youB Values.",
    instructions:
      " To complete your self-reflection, please share your name and email to receive your results. You can use your prioritized values to search for content and focus your efforts.",
  },
];
